import { DefaultMessages, ProgramThemeMessages, SegmentSpecificMessages } from '@sheerid/jslib';
import { RecursivePartial } from '../types/types';


type LibraryMessages = DefaultMessages & SegmentSpecificMessages & ProgramThemeMessages;

type ThisProjectMessages = {
    footer: string;
};


export const messagesEN: RecursivePartial<LibraryMessages & ThisProjectMessages> = {
    infoShared1: 'By clicking, I consent to processing my information for the purpose of verifying my eligibility as described within the ',
    infoShared2: '. I understand that my information will be shared with Athletic Propulsion Labs. Your information will be transferred to the United States and will be treated according to SheerID’s privacy policy.',
    footer: 'Verification services powered by SheerID. <a href="https://verify.sheerid.com/professions-faq/" class="sid-link" target="_blank">Get Help</a>',
    emailExplanation: 'Use your work email if you have one',
    step: {
        personalInfo: {
            title: 'Unlock this licensed professional-Only Offer',
            subtitle: 'Verify you\'re a licensed professional.',
            verifyingTitle: 'Verifying your licensed professional status',
        },
        docUpload: {
            title: 'We need some more info',
        },
    },
};
